module.exports = __webpack_public_path__ + "img/course-type-12-16-3.65798f59.png";